/**
 * Resolve a canonical Algolia subject value for the Browse Programs Catalog
 * component. The product index stores `subject` values in Title Case
 * (e.g. "Computer Science", "Business & Management"). Authors historically
 * pass `topic` as free-text (e.g. "graphic design") because the value was
 * fed to Algolia as a `query`. With structured filtering we need a single
 * canonical value, so we prefer an explicit `subject` shortcode attr and
 * Title Case the legacy `topic` as a fallback.
 */
const titleCase = (value: string): string =>
  value
    .trim()
    .split(/\s+/)
    .map((word) =>
      word.length === 0
        ? word
        : word[0].toUpperCase() + word.slice(1).toLowerCase(),
    )
    .join(" ");

export const normalizeSubject = (
  subject: string | undefined,
  topic: string | undefined,
): string => {
  if (subject && subject.trim().length > 0) {
    return subject.trim();
  }
  if (topic && topic.trim().length > 0) {
    return titleCase(topic);
  }
  return "";
};
